<template>

  <div>

    <vx-card>

      <div class="grid gap-4 items-end lg:grid-cols-7 md:grid-cols-1">
        <div>
          <label>Grupo Gerador</label>
          <vs-select
            v-model="companyGuid"
            autocomplete
            class="w-full">
            <vs-select-item :key="item.guid" :value="item.guid" :text="item.name" v-for="item in companies" class="w-full"/>
          </vs-select>
        </div>

        <div>
          <label>Cnpj do Grupo Gerador</label>
          <vs-select
            v-model="companyGuid"
            autocomplete
            class="w-full">
            <vs-select-item :key="item.guid" :value="item.guid" :text="(item.cnpjAlfa || item.cnpj) | formatCnpj" v-for="item in companies" class="w-full"/>
          </vs-select>
        </div>

        <div>
          <label>Nome da Usina</label>
          <vs-select
            v-model="ceg"
            autocomplete
            class="w-full">
            <vs-select-item :key="item.guid" :value="item.ceg" :text="item.powerPlantName" v-for="item in profiles" class="w-full"/>
          </vs-select>
        </div>

        <div>
          <label>CEG</label>
          <vs-select
            v-model="ceg"
            autocomplete
            class="w-full">
            <vs-select-item :key="item.guid" :value="item.ceg" :text="item.ceg" v-for="item in profiles" class="w-full"/>
          </vs-select>
        </div>

        <div> </div>

        <div>
          <vs-button
            class="w-full"
            @click="clearFilter()"
            icon-pack="fa"
            icon="fa-eraser"
            title="Limpar">
            <span class="auto-hide-clear-text">Limpar</span>
          </vs-button>
        </div>

        <div>
          <vs-button
            class="w-full"
            @click="refine()"
            icon="search">Buscar
          </vs-button>
        </div>
      </div>

    </vx-card>

    <vx-card class="mt-4">
      <CceeChart :values="values"/>
    </vx-card>

    <vx-card class="mt-4">
      <vs-row class="mb-4">
        <vs-col>
          <vs-button @click="download">Download</vs-button>
        </vs-col>
      </vs-row>

      <vs-table stripe :data="generatorGuaranteeTable" noDataText="Nenhum registro encontrado.">

        <template slot="thead">
          <th>Usina</th>
          <th>Ceg</th>
          <th>Mercado</th>
          <th>Tipo Energia</th>
          <th>Garantia Física (MWm)</th>
          <th>Geração</th>
          <th>Data</th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(row, indextr) in data">
            <td>
              <span v-if="row.powerPlantProfile != null">{{row.powerPlantProfile.powerPlant.siglaAtivo}}</span>
            </td>
            <td>
              <span v-if="row.powerPlantProfile != null">{{row.powerPlantProfile.powerPlant.ceg}}</span>
            </td>
            <td>
              <span v-if="row.powerPlantProfile != null">{{row.powerPlantProfile.powerPlant.market | formatMarket}}</span>
            </td>
            <td>
              <span v-if="row.powerPlantProfile != null">{{row.powerPlantProfile.energyType | formatEnergyType}}</span>
            </td>
            <td>
              {{row.physicalGuarantee | toDecimal}}
            </td>
            <td>
              {{row.avgGeneration | toDecimal}}
            </td>
            <td>
              {{row.date | formatDate}}
            </td>
          </vs-tr>
        </template>

      </vs-table>
    </vx-card>

  </div>
</template>

<script>

import CceeChart from "@/components/stats/CceeChart";
import axios from "axios";

export default {
  name: "GeradoraList",
  components: {
    CceeChart
  },
  data () {
    return {
      companyGuid: null,
      ceg: null,
      companies: [],
      profiles: [],
      profilesList: [],
      generatorGuaranteeTable: [],
      values: [
        {
          label: '',
          labels: [],
          datasets: [],
          data: [],
        }
      ],
    }
  },
  watch: {
    companyGuid (newValue) {
      this.ceg = null
      this.profiles = []
      this.profiles = this.profilesList[newValue]
      this.profiles.unshift({guid: '0000-0000', ceg: 'Todos', powerPlantName: 'Todos' })
    }
  },
  beforeMount() {
    this.loadCompanies()
    this.loadProfiles()
  },
  methods: {

    loadCompanies () {
      axios.get(`${process.env.VUE_APP_API}/api/v1/company/profiles`, {
        params: {
          profile: 'GENERATOR'
        }
      })
        .then((response) => {
          this.companies = response.data
        })
    },

    loadProfiles () {
      axios.get(`${process.env.VUE_APP_API}/api/v1/company/power-plant/ceg`)
        .then((response) => {
          this.profilesList = response.data
        })
    },

    refine () {
      if (this.ceg === 'Todos') {
        this.ceg = null
      }

      axios.get(`${process.env.VUE_APP_API}/api/v1/ccee/generator/${this.companyGuid}/chart`, {
        params: {
          ceg: this.ceg
        }
      })
        .then((response) => {
          if (response.data.length > 0) {
            this.values = response.data
          } else {
            this.values = [{
                label: '',
                labels: [],
                datasets: [],
                data: [],
              }]
          }
        })

      axios.get(`${process.env.VUE_APP_API}/api/v1/ccee/generator/${this.companyGuid}`)
        .then((response) => {
          this.generatorGuaranteeTable = response.data
        })

    },

    clearFilter() {
      this.companyGuid = ''
    },

    download() {
      axios.get(`${process.env.VUE_APP_API}/api/v1/ccee/generator/${this.companyGuid}/excel`,
        {
        responseType: 'blob'
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          const filename = response.headers["x-suggested-filename"];
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
        })
    },

  }
}
</script>

<style scoped>

</style>
